import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import shadow from 'styles/shadow'

import { Fonts } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

const LabelProductInventory = ({ lg, number }) => {
  const { t } = useTranslation()
  const isOutOfStock = number === 0 ? true : false
  const text = isOutOfStock ? t('labelProductInventoryOutOfStock') : t('labelProductInventoryItemsLeft', { number })

  return (
    <Label isOutOfStock={isOutOfStock} lg={lg}>
      {lg ? <Fonts.Medium>{text}</Fonts.Medium> : <Fonts.SmallTitleBold>{text}</Fonts.SmallTitleBold>}
    </Label>
  )
}

LabelProductInventory.propTypes = {
  number: PropTypes.number.isRequired,
  lg: PropTypes.bool,
}

export default LabelProductInventory

const Label = styled.div`
  padding: 2px 6px;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.bgColor};
  background-color: ${(props) => (props.isOutOfStock ? props.theme.colors.darkGrey : props.theme.colors.errorLight)};
  box-shadow: ${(props) => (props.lg ? shadow.heavey : shadow.soft)};

  @media (max-width: 371px) {
    div {
      font-size: 0.6em;
    }
  }
`
